<div *ngIf="data && data.segmentNames.length" class="segments">
  <mat-chip-list>
    <mat-chip *ngFor="let segment of data.segmentNames">
      {{ segment }}
    </mat-chip>
  </mat-chip-list>
</div>
